import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://api.timedetectives.augusta.museum",
  // baseURL: "http://localhost:3001",
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
